<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item @click="cancel"><a>课题引领</a></el-breadcrumb-item>
                <el-breadcrumb-item v-if="!topicId">新增课题</el-breadcrumb-item>
                <el-breadcrumb-item v-if="topicId">编辑课题</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card shadow="never" style="height: calc(100vh - 160px);overflow: auto;">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-row>
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="课题名称" prop="topicName">
                                    <el-input v-model="form.topicName" placeholder="最多32个字" maxlength="32" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="课题级别" prop="topicLevel">
                                    <el-select @change="getOrgListTypeOrg" v-model="form.topicLevel" placeholder="请选择课题级别">
                                        <el-option v-for="item in topicLevelList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="课题单位" prop="orgIdsList">
                                    <el-select style="width: 100%;" multiple filterable v-model="form.orgIdsList"
                                               placeholder="请选择课题单位">
                                        <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                                   :value="item.orgId" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="展示类型" prop="topicType">
                                    <el-radio-group v-model="form.topicType">
                                        <el-radio :label="0">文字展示</el-radio>
                                        <el-radio :label="1">图片展示</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="22">
                                <el-form-item label="课题方向" prop="topicClassifyKey">
                                    <el-select style="width: 100%;" v-model="form.topicClassifyKey" placeholder="请选择课题方向">
                                        <el-option v-for="item in topicClassifyList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey">
                                            <span style="float: left">{{ item.dictValue }}</span>
                                            <span @click.stop="delFx(item)" style="float: right; color: #8492a6; font-size: 13px">
                                        <el-icon>
                                            <Delete />
                                        </el-icon>
                                    </span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                <el-icon @click="openLeadClassify" class="ml15 cursor" :size="30">
                                    <CirclePlus />
                                </el-icon>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="10">
                        <el-form-item label="课题封面" prop="coverUrl">
                                <el-upload class="avatar-uploader"
                                           :action="serviceUrl+'/businessservice/train/uploadCover'" :show-file-list="false"
                                           :on-success="handleCoverSuccess" :headers="{ token }" :before-upload="beforeAvatarUpload">
                                    <img alt="" v-if="form.coverUrl" :src="form.coverUrl" class="avatar" style="position:absolute" />
                                    <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                        <Plus />
                                    </el-icon>
                                </el-upload>
                                <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                            </el-form-item>
                    </el-col>
                </el-row>




                <el-row>
                    <el-col :span="12">
                        <el-form-item label="课题负责人" prop="leader">
                            <choosePeople :showTitle="'选择人员'" :radio="true" ref="leader" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系方式" prop="contactInfo">
                            <el-input v-model="form.contactInfo" placeholder="请输入联系方式"  />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课题审核人" prop="checkUsersList">
                            <choosePeople :showTitle="'选择人员'" ref="checkUsersList" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="子课题数量" prop="topicCount">
                            <el-input-number v-model="form.topicCount" step-strictly :min="1" :max="100" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="申报时间" prop="applyFormTime">
                            <el-col :span="11" class="date_picker">
                                <el-date-picker format="YYYY-MM-DD HH:mm" @change="startApplyDateConfirm" :disabled-date="disabledDate"
                                    style="width: 100%;" v-model="form.applyBeginTime" type="datetime" placeholder="开始时间"
                                    value-format="x" />
                            </el-col>
                            <el-col :span="2" class="text-center">
                                <span class="text-gray-500">至</span>
                            </el-col>
                            <el-col :span="11">
                                <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" @change="endApplyDateConfirm"
                                     style="width: 100%;" v-model="form.applyEndTime"
                                    type="datetime" placeholder="结束时间" value-format="x" />
                            </el-col>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="验收时间" prop="checkFormTime">
                            <el-col :span="11" class="date_picker">
                                <el-date-picker format="YYYY-MM-DD HH:mm" @change="startDateConfirm" :disabled-date="disabledDate"
                                                style="width: 100%;" v-model="form.checkBeginTime" type="datetime" placeholder="开始时间"
                                                value-format="x" />
                            </el-col>
                            <el-col :span="2" class="text-center">
                                <span class="text-gray-500">至</span>
                            </el-col>
                            <el-col :span="11">
                                <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" @change="endDateConfirm"
                                                style="width: 100%;" v-model="form.checkEndTime"
                                                type="datetime" placeholder="结束时间" value-format="x" />
                            </el-col>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                    </el-col>
                </el-row>
                <el-row v-if="form.topicType === 0">
                    <el-col :span="12">
                        <el-form-item label="课题介绍" prop="recommend">
                            <el-input type="textarea"  v-model="form.recommend" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="form.topicType === 0">
                    <el-col :span="12">
                        <el-form-item label="研究目的" prop="studyAim">
                            <el-input type="textarea"  v-model="form.studyAim" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="form.topicType === 0">
                    <el-col :span="12">
                        <el-form-item label="研究方法" prop="studyMethod">
                            <el-input type="textarea"  v-model="form.studyMethod" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="其他" prop="remarks">
                            <el-input type="textarea" maxlength="1000" v-model="form.remarks" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上传附件" prop="">
                            <el-upload v-model:file-list="fileList" class="upload-demo" :on-remove="handleRemove"
                                :action="serviceUrl+'/businessservice/topic/lead/uploadFile'"
                                :on-change="handleJAChange" :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx"
                                :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="form.topicType === 1">
                    <el-col :span="12">
                        <el-form-item label="课题图片" prop="imgUrl">
                            <el-upload class="avatar-uploader"
                                :action="serviceUrl+'/businessservice/topic/lead/uploadCover'"
                                :show-file-list="false" :on-success="handleAvatarSuccess" :headers="{ token }"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar" style="position:absolute" />
                                <el-icon class="avatar-uploader-icon" style="font-size:60px;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>

        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:226px;'">
                <el-button @click="cancel">取 消</el-button>
                <el-button @click="saveDraft">暂 存</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
        <!-- 创建课题方向-->
        <el-dialog :title="'创建课题方向'" v-model="topicClassifyShow" width="60%">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="名称" prop="orgName">
                        <el-input v-model="classifyName" placeholder="最多32个字" maxlength="32" />
                    </el-form-item>
                </el-col>
            </el-row>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitTopicClassifyForm">确 定</el-button>
                    <el-button @click="topicClassifyShow = false">取 消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { queryDict, userList, deleteDict } from "@/api/admin/public";
import { orgListTypeOrg } from "@/api/admin/system";
import { leadAddClassify, leadDeleteFile } from "@/api/admin/lead";
import { serviceUrl } from "@/utils/global"
import { createTopic,updateTopic,infoTopic} from "@/api/admin/topic"
export default {
    name: "topicAdd",
    components: {},
    data() {
        return {
            serviceUrl,
            topicClassifyShow: false,
            classifyName: '',
            fileList: [],
            toParentsMap: {},
            isShow: false,
            oldCenter: [],
            topicId: '',
            periodList: [],
            gradeList: [],
            subjectList: [],
            topicClassifyList: [],
            orgList: [],
            topicLevelList: [],
            userList: [],
            token: this.$storage.get("token"),
            // 遮罩层
            loading: true,
            // 非单个禁用
            single: true,
            // 表单参数
            form: {
                coverUrl: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png',
                groupId: '',
                topicNature: '1',
                topicName: '',
                topicLevel: '',
                topicType: 0,
                topicClassifyKey: '',
                leader: '',
                contactInfo:"",
                topicCount: 10,
                recommend: '',
                checkUsersList: [],
                orgIdsList: [],
                trainLevel: '',
                applyBeginTime: '',
                applyEndTime: '',
                checkBeginTime: '',
                checkEndTime: '',
                studyAim: '',
                studyMethod: '',
                remarks: '',
                fileUrls: '',
                imgUrl: '',
            },
            groupList: [],
            natureList: [],
            // 表单校验
            rules: {
                topicNature: [
                    { required: true, message: "请选择课题性质", trigger: "change" },
                ],
                checkUsersList: [
                    { required: true, validator: this.checkcheckUsersList },
                ],
                orgIdsList: [
                    { required: true, message: "请选择课题单位", trigger: "change" },
                ],
                topicName: [
                    { required: true, message: "请输入课题名称", trigger: "blur" },
                ],
                contactInfo: [
                    { required: true, message: "请输入联系方式", trigger: "blur" },
                ],
                topicClassifyKey: [
                    { required: true, message: "请选择课题方向", trigger: "change" },
                ],
                topicLevel: [
                    { required: true, message: "请选择课题级别", trigger: "change" },
                ],
                topicCount: [
                    { required: true, message: "请选择子课题数数", trigger: "change" },
                ],
                topicType: [
                    { required: true, message: "请选择课题类型", trigger: "change" },
                ],
                trainLevel: [
                    { required: true, message: "请选择培训级别", trigger: "change" },
                ],
                leader: [
                    { required: true, message: "请选择课题负责人", trigger: "change" },
                ],
                applyFormTime: [
                    { required: true, validator: this.checkApplyValidator }
                ],
                checkFormTime: [
                    { required: true, validator: this.checkCheckValidator }
                ],
                imgUrl: [
                    { required: true, validator: this.checkCoverValidator }
                ]
            },
            delFileList: [],
            countyList: [],
            schoolList: [],
            rateScaleList: [],
            previewData: {},
            previewShow: false,
            // 草稿中暂存的已选人员，待组件挂载后回显
            draftLeaderList: [],
            draftCheckUserList: [],
        };
    },
    created() {
        this.getOrgListTypeOrg();
        this.getQueryDict();
        // 仅纯创建场景（无 topicId）回显草稿
        if (!this.$route.query.topicId) {
            const draft = this.$storage.get('topicAddDraft');
            if (draft) {
                Object.assign(this.form, draft.form);
                this.draftLeaderList = draft.leaderList || [];
                this.draftCheckUserList = draft.checkUserList || [];
                // 按草稿中的课题级别加载课题单位选项，保证多选框正常回显
                if (this.form.topicLevel) {
                    orgListTypeOrg({ orgType: this.form.topicLevel }).then(res => {
                        this.orgList = res.data.data;
                    })
                }
            }
        }
    },
    mounted() {
        if (this.$route.query.topicId) {
            this.topicId = this.$route.query.topicId
            this.getTopicInfo()
        } else {
            // 回显草稿中已选择的课题负责人和审核人
            if (this.draftLeaderList.length && this.$refs.leader) {
                this.$refs.leader.checkList = this.draftLeaderList;
            }
            if (this.draftCheckUserList.length && this.$refs.checkUsersList) {
                this.$refs.checkUsersList.checkList = this.draftCheckUserList;
            }
        }
    },
    unmounted() {
        if (this.topicId) {
            try {
                this.fileList.forEach(e => {
                    console.log(e)
                    if (e.response.code) {
                        leadDeleteFile({ fileUrl: e.response.data });
                    }
                })
            } catch (e) {
            }
        } else {
            try {
                this.fileList.forEach(e => {
                    leadDeleteFile({ fileUrl: e.response.data });
                })
            } catch (e) {
            }

        }
    },
    computed: {},
    methods: {
        delFx(item) {
            var _this = this;
            ElMessageBox.confirm(
                '是否删除该课题方向?',
                '删除',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            ).then(() => {
                deleteDict({ dicId: item.dicId }).then(res => {
                    if (res.data.code == 1) {
                        if (_this.form.topicClassifyKey == item.dictKey) {
                            _this.form.topicClassifyKey = ''
                        }
                        _this.$message.success('删除成功')
                        queryDict({ code: 'topic_classify' }).then(res => {
                            _this.topicClassifyList = res.data.data;
                        })
                    } else {
                        _this.$message.error('操作失败')
                    }
                })
            }).catch(() => {

            })
        },
        checkcheckUsersList(rule, value, callback) {
            if (this.$refs.checkUsersList.checkList.length == 0) {
                callback(new Error('请选择审核人员'))
            } else {
                callback()
            }
        },
        preview(item) {
            console.log(item)
            rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                this.previewData = res.data.data;
                this.previewShow = true;
            })
        },
        sxKj() {
            this.$refs.leader.checkList = []
            this.$refs.checkUsersList.checkList = []
        },
        checkCoverValidator(rule, value, callback) {
            if (this.form.imgUrl != '') {
                callback()
            } else {
                callback(new Error('请上传课题介绍图片'))
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.form.imgUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.form.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        openLeadClassify() {
            this.classifyName = ''
            this.topicClassifyShow = true;
        },
        submitTopicClassifyForm() {
            leadAddClassify({ classifyName: this.classifyName }).then(res => {
                if (res.data.code == 1) {
                    this.getQueryDict();
                    this.$message.success('添加成功')
                    this.topicClassifyShow = false;
                } else {
                    this.$message.error('添加失败')
                }
            })
        },
        handleRemove(file, uploadFiles) {
            console.log("删除文件了")
            if (file.response.data) {
                this.delFileList.push(file.response.data)
            }
        },
        getTopicInfo() {
            infoTopic({ topicId: this.topicId }).then(res => {
                this.form = res.data.data;
                this.$refs.leader.checkList = this.form.leaderList;
                this.$refs.checkUsersList.checkList = this.form.checkUserList;
                this.form.orgIdsList = res.data.data.orgIds.split(',')
                orgListTypeOrg({ orgType: this.form.topicLevel }).then(res => {
                    this.orgList = res.data.data;
                })
                this.form.fileList.forEach(e => {
                    this.fileList.push({
                        name: e.fileName,
                        fileId: e.fileId,
                        url: e.fileUrl,
                        response: {
                            data: e.fileUrl
                        }
                    })
                })
            })
        },
        handleXTChange(file) {},
        handleJAChange(file) {},
        handleKjChange(file) {},
        beforeJAUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        startDateConfirm(e) {
            // if (e >= this.form.checkEndTime) {
            //     this.form.checkEndTime = '';
            // }
        },
        startApplyDateConfirm(e) {
            // if (e >= this.form.applyEndTime) {
            //     this.form.applyEndTime = '';
            // }
        },
        endDateConfirm(e) {
            // if (e <= this.form.beginTime) {
            //     this.form.beginTime = '';
            // }
        },
        endApplyDateConfirm(e) {
            // if (e <= this.form.applyBeginTime) {
            //     this.form.applyBeginTime = '';
            // }
        },
        checkValidator(rule, value, callback) {
            if (this.form.beginTime === '' || !this.form.beginTime) {
                callback(new Error('请选择开始时间'))
            } else if (this.form.endTime === '' || !this.form.endTime) {
                callback(new Error('请选择结束时间'))
            } else if(this.form.endTime <this.form.beginTime) {
                this.form.endTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            }else {
                callback()
            }
        },
        checkApplyValidator(rule, value, callback) {
            if (this.form.applyBeginTime === '' || !this.form.applyBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (this.form.applyEndTime === '' || !this.form.applyEndTime) {
                callback(new Error('请选择结束时间'))
            } else if(this.form.applyEndTime <this.form.applyBeginTime) {
                this.form.applyEndTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            }else {
                callback()
            }
        },
        checkCheckValidator(rule, value, callback) {
            if (this.form.applyEndTime === '' || !this.form.applyEndTime){
                callback(new Error('请选择申报结束时间'))
            }else if (this.form.checkBeginTime === '' || !this.form.checkBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if(this.form.checkBeginTime < this.form.applyEndTime){
                callback(new Error('验收开始时间必须大于申报结束时间'))
            } else if (this.form.checkEndTime === '' || !this.form.checkEndTime) {
                callback(new Error('请选择结束时间'))
            } else if(this.form.checkEndTime <this.form.checkBeginTime) {
                this.form.checkEndTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            }else {
                callback()
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        enddisabledDate(current) {
            if (this.form.beginTime) {
                return current && current < this.form.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
        getOrgListTypeOrg() {
            this.form.orgIdsList = [];
            orgListTypeOrg({ orgType: this.form.topicLevel }).then(res => {
                this.orgList = res.data.data;
            })
        },
        getQueryDict() {
            queryDict({ code: 'topic_classify' }).then(res => {
                this.topicClassifyList = res.data.data;
            })
            queryDict({ code: 'topic_level' }).then(res => {
                this.topicLevelList = res.data.data;
            })
            userList().then(res => {
                this.userList = res.data.data;
            })
        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        // 暂存草稿
        saveDraft() {
            const draft = {
                form: JSON.parse(JSON.stringify(this.form)),
                leaderList: this.$refs.leader ? JSON.parse(JSON.stringify(this.$refs.leader.checkList)) : [],
                checkUserList: this.$refs.checkUsersList ? JSON.parse(JSON.stringify(this.$refs.checkUsersList.checkList)) : [],
            }
            this.$storage.set('topicAddDraft', draft);
            this.$message.success('已暂存')
        },
        /** 提交按钮 */
        submitForm() {
            this.form.checkUsersList = [];
            this.form.applyBeginTime = this.setHms(this.form.applyBeginTime);
            this.form.applyEndTime = this.setHms(this.form.applyEndTime);
            this.form.checkBeginTime = this.setHms(this.form.checkBeginTime);
            this.form.checkEndTime = this.setHms(this.form.checkEndTime);

            if (this.$refs.leader.checkList.length !== 0) {
                this.form.leader = this.$refs.leader.checkList[0].userId
            } else {
                this.form.leader = ''
            }
            this.$refs.checkUsersList.checkList.forEach(e => {
                this.form.checkUsersList.push(e.userId)
            })
            var fileList = [];
            this.fileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.form.checkUsers = this.form.checkUsersList.toString()
            this.form.orgIds = this.form.orgIdsList.toString()
            this.$refs["form"].validate(valid => {
                if (valid) {
                    const obj = JSON.parse(JSON.stringify(this.form));
                    obj.fileUrls = fileList.toString();
                    delete obj.checkUsersList
                    delete obj.orgIdsList
                    if (this.topicId) {
                        updateTopic(obj).then(res => {
                            if (res.data.code === 1) {
                                this.$storage.remove('topicAddDraft');
                                this.fileList = []
                                this.delFileList.forEach(e => {
                                    leadDeleteFile({ fileUrl: e });
                                })
                                this.$message.success("操作成功");
                                this.replace('/topic')
                            } else {
                                this.$message.error("操作失败")
                            }
                        })
                    } else {
                        createTopic(obj).then(res => {
                            if (res.data.code === 1) {
                                this.$storage.remove('topicAddDraft');
                                this.fileList = []
                                this.delFileList.forEach(e => {
                                    leadDeleteFile({ fileUrl: e });
                                })
                                this.$message.success("操作成功");
                                this.replace('/topic')
                            } else {
                                this.$message.error("操作失败")
                            }
                        })
                    }
                }
            });
        },
        // 取消按钮
        cancel() {
            this.replace('/topic')
        },
    }
};
</script>
<style scoped>
.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

/deep/ .el-dialog__body {
    padding: 10px 20px !important;
}

.custom /deep/ .el-checkbox {
    height: auto !important;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.custom /deep/ .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
}

.custom /deep/ .el-checkbox__label {
    padding-left: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
}

.custom {
    height: calc(100vh - 500px);
    overflow-y: auto;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    position: relative;
}

.ylsb {
    height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
}

.ylqs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 7px;
    padding: 5px;
    cursor: pointer;
}

.eicon {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 5px;
    background: #dbdbdb;
}

.csbbb:hover .eicon {
    display: block;
}
</style>